<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">权限设置</span></div>
    <div class="margin-top margin-left">
      <Button :disabled="datas.length >= User.accountingNum" class="mr-16px" color="primary" @click="showForm=true">新增</Button>
      <span>最大用户数： <b>{{ User.useNum <= 10 ? User.useNum : "不限人数"}}</b> 人，更多会计人数请联系服务商购买~</span>
    </div>
    <div class="h-panel-body">
      <vxe-table :data="datas" :border="true">
        <vxe-column title="用户" field="realName"></vxe-column>
        <vxe-column title="手机号" field="mobile"></vxe-column>
        <!-- <vxe-column title="权限" field="role" :formatter="({cellValue})=>dictMapping(cellValue,'roles')"></vxe-column> -->
        <vxe-column>
          <template #default="{row}">
            <div class="actions">
              <!-- <span @click="showHandOver=true" v-if="currentAccountSets.creatorId === row.id && row.id === User.id">移交</span> -->
              <template v-if="User.id !== row.id && currentAccountSets.creatorId !== row.id">
                <span @click="edit(row)">编辑</span>
                <span @click="remove(row)">删除</span>
              </template>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <Modal v-model="showForm" hasCloseIcon>
      <template #header>授权账套：<span style="color: tomato;">{{ currentAccountSets.companyName }}</span></template>
      <Form ref="form" :labelWidth="80" :model="form" :rules="validationRules" mode="block">
        <FormItem label="手机用户" prop="mobile">
          <Input type="text" v-model="form.mobile" :disabled="form.id"/>
        </FormItem>
        <FormItem label="角色权限" prop="role">
          <Radio class="cus-h-radio" v-model="form.role" :datas="roles" required>
            <template slot="item" slot-scope="{item}">
              <span>{{ item.title }}</span>
              <div class="desc">{{ item.desc }}</div>
            </template>
          </Radio>
        </FormItem>
      </Form>
      <div class="text-center margin-top w-400px">
        <Button color="green" @click="addUser" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showNewForm" hasCloseIcon>
      <template #header>新增权限</template>
      <div class="margin">
        亲，您输入的手机还没有注册，确认需要新增吗？
        为保障您的数据安全，新注册用户需要验证手机，
        <span style="color: tomato">注册成功后默认密码为手机号码。</span>
        <span style="color: tomato">请注意及时更改！</span>
      </div>
      <Row type="flex" :space="10" class="margin">
        <Cell><Input type="text" v-model="form.mobile" disabled/></Cell>
        <Cell>
          <SmsVerificationCode :mobile="form.mobile"/>
        </Cell>
      </Row>
      <Row type="flex" :space="10" class="margin">
        <Cell><Input v-model="msgCode" type="text" placeholder="请输入验证码"/></Cell>
      </Row>
      <div class="text-center">
        <Button color="green" @click="addNewUser" :loading="loading">确定</Button>
        <Button @click="showNewForm=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showHandOver" hasCloseIcon>
      <template #header>移交账套</template>
      <div class="margin">
        <template v-if="authenticated">
          请验证接收人的手机，他即将接收的账套是：
        </template>
        <template v-else>
          请验证移交人的手机，您即将移交的账套是：
        </template>
        <br>
        {{ currentAccountSets.companyName }}
        <p class="red-color">注意：移交账套后，您将不能再查看该账套！</p>
      </div>
      <div v-show="authenticated">
        <div class="margin h-input-group">
          <Input type="text" v-model="receiverMobile" placeholder="请输入接收人手机"/>
          <SmsVerificationCode :mobile="receiverMobile"/>
        </div>
        <div class="margin">
          <Input v-model="verificationCode" type="text" placeholder="请输入验证码"/>
        </div>
      </div>
      <div v-show="!authenticated">
        <div class="margin h-input-group">
          <Input type="text" v-model="User.mobile" disabled/>
          <SmsVerificationCode :mobile="User.mobile"/>
        </div>
        <div class="margin">
          <Input v-model="verificationCode" type="text" placeholder="请输入验证码"/>
        </div>
      </div>
      <div class="text-center">
        <Button color="red" @click="handOver" :loading="loading">确定</Button>
        <Button @click="showHandOver=false">取消</Button>
      </div>
    </Modal>
  </app-content>
</template>

<script>

import {mapState} from 'vuex';
import SmsVerificationCode from "../../components/SmsVerificationCode";

const emptyForm = {
  "role": "",
  "mobile": "",
};

export default {
  name: 'PermissionSetting',
  components: {SmsVerificationCode},
  data() {
    return {
      datas: [],
      roles: [],
      form: Object.assign({}, emptyForm),
      showNewForm: false,
      showHandOver: false,
      showForm: false,
      loading: false,
      authenticated: false,
      receiverMobile: '',
      msgSended: false,
      msgTxt: '发送验证码',
      msgCode: '',
      verificationCode: '',
      validationRules: {
        required: ['mobile','role'],
        mobile: ['mobile']
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets', 'User']),
  },
  watch: {
    showForm(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  created() {
    if(this.User.version == "base"){
      this.roles = [
        {
          key: 'ManagerBase',
          title: '账套管理员',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 | 删除账套'
        }, {
          key: 'MakingBase',
          title: '制单人',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 '
        }, {
          key: 'ViewBase',
          title: '查看',
          desc: '查看凭证、账簿和报表 | 新增账套'
        }]
    }else if(this.User.version == "major"){
      this.roles = [
        {
          key: 'ManagerMajor',
          title: '账套管理员',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 | 删除账套'
        }, {
          key: 'MakingMajor',
          title: '制单人',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 '
        }, {
          key: 'ViewMajor',
          title: '查看',
          desc: '查看凭证、账簿和报表 | 新增账套'
        }]
    }else{
      this.roles = [
        {
          key: 'ManagerFlagship',
          title: '账套管理员',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 | 删除账套'
        }, {
          key: 'MakingFlagship',
          title: '制单人',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 '
        }, {
          key: 'ViewFlagship',
          title: '查看',
          desc: '查看凭证、账簿和报表 | 新增账套'
        }]
    }
  },
  methods: {
    loadList() {
      this.$api.setting.user.list().then(({data}) => {
        this.datas = data || [];
      })
    },
    addUser() {
      if(!this.form.mobile || !this.form.role){
        this.$Message('手机号和角色权限是必填项！');
        return;
      }
      if(this.User.useNum > this.datas.length){
        let validResult = this.$refs.form.valid();
        if (validResult.result) {
          this.loading = true;
          this.$api.setting.accountSets[this.form.id ? 'updateUserRole' : 'addUser'](this.form).then(() => {
            this.loadList();
            this.showForm = false;
            this.loading = false;
          }).catch((rs) => {
            this.loading = false;
            if (rs.code === 501) {
              this.showNewForm = true;
            }
          });
        }
      }else{
        this.$Message('已达到最大用户数，无法添加！');
      }
    },
    addNewUser() {
      if (!this.msgCode) {
        this.$Message('请输入验证码！');
        return
      }
      this.loading = true;
      this.$api.setting.accountSets.addNewUser(Object.assign({}, this.form, {code: this.msgCode})).then(() => {
        this.loadList();
        this.$Message('注册成功，默认密码为手机号码')
        this.showForm = false;
        this.showNewForm = false;
        this.msgCode = '';
        this.loading = false;
      }).catch((rs) => {
        this.loading = false;
      });
    },
    edit(data) {
      this.form = {
        role: data.role,
        mobile: data.mobile,
        id: data.id
      };
      this.showForm = true;
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.setting.accountSets.removeUser(data.id).then(() => {
          this.loadList();
        })
      })
    },
    reset() {
      this.form = Object.assign({}, emptyForm);
    },
    handOver() {
      if (this.verificationCode) {
        if (!this.authenticated) {
          //移交人身份确认
          this.$api.setting.accountSets.identification({code: this.verificationCode}).then(() => {
            this.verificationCode = "";
            this.authenticated = true;
          });
        } else {
          //移交亲，请再次确定是否移交该账套，移交成功后，接收人登录柠檬云即可查看该账套：浙江欧易新能源有限公司
          this.$api.setting.accountSets.handOver({mobile: this.receiverMobile, code: this.verificationCode}).then(() => {
            window.location.replace("/");
          });
        }
      }
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>
<style lang="less">
.cus-h-radio {
  > label {
    display: block;
    height: auto;

    .desc {
      color: @dark4-color;
      padding-left: 20px;
    }
  }
}
</style>
